{
  "en": {
    "ai": {
      "assistant": {
        "all_projects": "All projects",
        "cap": {
          "action": "Start a new conversation",
          "message": "You've reached the conversation limit."
        },
        "empty_state": {
          "subtitle": "Ask me anything about your clients",
          "title": "How can I help you?"
        },
        "errors": {
          "budget_reached": "This month's AI budget has been used. Contact Ziggu to raise it.",
          "generic": "Something went wrong. Please try again."
        },
        "history": {
          "empty": "No past conversations yet",
          "title": "Past conversations"
        },
        "input": {
          "disclaimer": "Results may be inaccurate. Always verify important information.",
          "hint": "Enter to send · Shift+Enter for new line",
          "placeholder": "Ask about your clients..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "How do I set up notifications?",
          "help_project_settings": "Where do I find project settings?",
          "open_decisions": "Which decisions are still open?",
          "unassigned_units": "Which units have no customer yet?"
        },
        "support_cta": {
          "action": "Contact support",
          "prompt": "Not the answer you were looking for?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "All modules",
          "assistant": "Assistant",
          "conversation_agent": "Conversation agent",
          "label": "Module"
        },
        "clients": {
          "allowance_split": "Free {free} · Paid {paid}",
          "columns": {
            "allowance": "Allowance",
            "chats": "Chats in range",
            "client": "Client",
            "spend": "Spend in range",
            "status": "Status",
            "used": "Used this month"
          },
          "empty": "No client used AI in this range",
          "export": "Export",
          "title": "Clients"
        },
        "empty_hint": "Nothing matched this module and date range.",
        "intent_mix": {
          "empty": "No chats in this range",
          "row": "{chats} chat · {amount} | {chats} chats · {amount}",
          "title": "Intent mix"
        },
        "intents": {
          "draft": "Draft a reply",
          "none": "No intent",
          "question": "Ask",
          "summary": "Summary"
        },
        "kpi": {
          "clients_active": "Active clients",
          "employees_active": "Active employees",
          "spend_month": "Spend this month",
          "spend_month_detail": "Calendar month to date",
          "spend_range": "Spend in range",
          "spend_range_detail": "{count} chat in this range | {count} chats in this range",
          "spend_today": "Spend today",
          "tickets_assisted": "Tickets assisted"
        },
        "load_failed": {
          "description": "Reload the page or try another range.",
          "title": "Couldn't load the AI usage"
        },
        "range": {
          "label": "Date range"
        },
        "spend": {
          "empty": "No spend in this range",
          "monthly_empty": "No spend in the last {months} months",
          "monthly_hint": "Last {months} months · not affected by the date range",
          "monthly_title": "Cost per month",
          "monthly_total": "{amount} in the last {months} months · not affected by the date range",
          "title": "Spend per day",
          "total": "{amount} in range",
          "view": {
            "label": "Show spend",
            "per_day": "Per day",
            "running_total": "Running total"
          }
        },
        "status": {
          "over": "Over budget",
          "over_days": "Over · 1 day | Over · {count} days"
        },
        "title": "AI usage"
      },
      "settings": {
        "budget": {
          "description": "Monthly cost cap for AI usage (test phase). Recalculated based on token usage across all conversations this month.",
          "free_label": "Free allowance",
          "override_help": "Leave empty to use the package amount ({amount}).",
          "override_label": "Free allowance override",
          "paid_label": "Paid allowance",
          "save": "Save",
          "title": "Monthly budget",
          "total_label": "Total allowance",
          "usage_label": "Used this month",
          "use_package_amount": "Use package amount"
        },
        "description": "Configuration for AI features in your organisation.",
        "title": "AI settings",
        "usage": {
          "description": "How much of this month's AI allowance is used. At 100% the AI features stop until the allowance resets next month.",
          "title": "AI usage"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Adjust",
          "ask": "Ask",
          "draft": "Draft a reply",
          "draft_empty": "No messages to reply to yet",
          "follow_up": "Follow up",
          "follow_up_stop": "Stop following up",
          "new": "New question",
          "summary": "Summarise conversation",
          "summary_empty": "No messages to summarise yet",
          "use_as_reply": "Use as reply"
        },
        "adjusting_draft": "Adjusting this draft",
        "beta": "Beta",
        "budget": {
          "description": "This month's AI budget has been used. Your earlier answers stay available.",
          "request": "We have used this month's AI budget and would like to raise it.",
          "request_low": "We have almost used this month's AI budget and would like to raise it.",
          "title": "AI budget reached",
          "warn": "{percent}% of this month's AI budget used."
        },
        "cap": "This chat has grown long. Ask a new question instead.",
        "collapse": "Hide assistant",
        "conversation": "Conversation",
        "digest": {
          "decisions_open": "no open decisions | 1 open decision | {count} open decisions",
          "installments_unpaid": "no unpaid installments | 1 unpaid installment | {count} unpaid installments",
          "issues_open": "no open aftercare issues | 1 open aftercare issue | {count} open aftercare issues",
          "nothing_open": "Nothing open on this unit",
          "overdue": "{count} overdue",
          "title": "At a glance"
        },
        "earlier_answers": "Earlier answers",
        "empty": "Ask about this conversation, or start with one of these.",
        "expand": "Show assistant",
        "following_up": "Following up this answer",
        "footer": "Only you can see this. Answers are made by AI and can contain errors.",
        "input": {
          "adjust_draft": "Adjust this draft, e.g. shorter or more formal",
          "follow_up": "Ask a follow-up",
          "label": "Your question",
          "placeholder": "Ask about this conversation"
        },
        "links": {
          "aftercare": "Aftercare",
          "decisions": "Decisions",
          "financials": "Financials"
        },
        "placeholders": {
          "confirm": {
            "accept": "Send anyway",
            "header": "Send with placeholders?",
            "message": "The assistant left 1 placeholder in this reply that you have not filled in yet. | The assistant left {count} placeholders in this reply that you have not filled in yet."
          },
          "remaining": "1 placeholder to fill in | {count} placeholders to fill in"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Replace",
            "header": "Replace what you typed?",
            "message": "The draft replaces the text in the reply box."
          }
        },
        "suggestions": {
          "history": "What is the history with this customer?",
          "issues_open": "How many aftercare issues are still open?",
          "undecided": "What has this customer not decided yet?"
        },
        "thinking": "The assistant is working...",
        "title": "Assistant"
      }
    }
  }
}
